// extracted by mini-css-extract-plugin
export var border = "_h-7";
export var brand = "_h-r";
export var button = "_h-j";
export var center = "_h-9";
export var centered = "_h-5";
export var closeButton = "_h-b";
export var disabledWrapper = "_h-k";
export var error = "_h-n";
export var extraLarge = "_h-4";
export var extraSmall = "_h-1";
export var fill = "_h-g";
export var footer = "_h-f";
export var footerAction = "_h-h";
export var footerButtons = "_h-i";
export var header = "_h-6";
export var icon = "_h-m";
export var info = "_h-q";
export var inline = "_h-8";
export var large = "_h-3";
export var main = "_h-c";
export var modal = "_h-0";
export var neutral = "_h-s";
export var noPadding = "_h-e";
export var none = "_h-t";
export var scrollable = "_h-d";
export var small = "_h-2";
export var success = "_h-p";
export var tight = "_h-l";
export var titleIcon = "_h-a";
export var warn = "_h-o";